import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "guest_copy" }

import Avatar2 from '@/assets/img/meeting-room/avatar-2.png';
import CloseIcon from '@/assets/img/meeting-room/close-f.png';


export default /*@__PURE__*/_defineComponent({
  __name: 'MeetingRoomGuestTip',
  props: {
    touristDuration: {}
  },
  emits: ["close", "login"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_a_alert = _resolveComponent("a-alert")!

  return (_openBlock(), _createBlock(_component_a_alert, {
    class: "guest_tip",
    type: "info",
    banner: "",
    "show-icon": false
  }, {
    message: _withCtx(() => [
      _createElementVNode("button", {
        class: "guest_close",
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _createElementVNode("img", {
          src: _unref(CloseIcon),
          alt: ""
        }, null, 8, _hoisted_1)
      ]),
      _createElementVNode("img", {
        class: "guest_avatar",
        src: _unref(Avatar2),
        alt: ""
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, _toDisplayString(_ctx.$t('游客模式 · 可观看{number}分钟', {
              number: _ctx.touristDuration,
            })), 1),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('参与互动请前往 Envo APP 登录')), 1)
      ]),
      _createElementVNode("button", {
        class: "guest_login",
        type: "button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('login')))
      }, _toDisplayString(_ctx.$t('登录')), 1)
    ]),
    _: 1
  }))
}
}

})